module.exports = __webpack_public_path__ + "static/media/male.4748b180.jpg";